type VesselsNotFoundSearchIconProps = {
  outerFill?: string; // default: "#E9F4F3"

  innerFill?: string; // default: "#D4EBE7"

  glyphFill?: string; // default: "#1F8475"

  size?: number | string;
} & React.SVGProps<SVGSVGElement>;

export const VesselsNotFoundSearchIcon: React.FC<VesselsNotFoundSearchIconProps> = ({
  outerFill = "#E9F4F3",
  innerFill = "#D4EBE7",
  glyphFill = "#1F8475",
  size = 104,
  ...rest
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 104 104"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden={rest["aria-label"] ? undefined : true}
    {...rest}
  >
    <rect width="104" height="104" rx="52" fill={outerFill} />
    <rect x="8" y="8" width="88" height="88" rx="44" fill={innerFill} />
    <path
      d="M71.5113 69.1561L61.563 59.2078C64.274 55.8921 65.6069 51.6613 65.286 47.3904C64.9652 43.1195 63.015 39.1353 59.8389 36.262C56.6629 33.3886 52.504 31.8459 48.2224 31.953C43.9408 32.06 39.8641 33.8086 36.8357 36.8371C33.8072 39.8656 32.0586 43.9423 31.9515 48.2238C31.8445 52.5054 33.3872 56.6644 36.2605 59.8404C39.1339 63.0165 43.118 64.9666 47.3889 65.2875C51.6598 65.6084 55.8906 64.2755 59.2063 61.5644L69.1546 71.5128C69.469 71.8164 69.89 71.9844 70.327 71.9806C70.764 71.9768 71.182 71.8015 71.491 71.4925C71.8 71.1835 71.9753 70.7654 71.9791 70.3284C71.9829 69.8914 71.8149 69.4704 71.5113 69.1561ZM48.6663 62.0011C46.0292 62.0011 43.4514 61.2191 41.2587 59.754C39.066 58.2889 37.3571 56.2066 36.3479 53.7702C35.3387 51.3339 35.0747 48.653 35.5892 46.0666C36.1036 43.4802 37.3735 41.1044 39.2382 39.2397C41.1029 37.375 43.4787 36.1051 46.0651 35.5906C48.6515 35.0762 51.3324 35.3402 53.7688 36.3494C56.2051 37.3585 58.2875 39.0675 59.7526 41.2602C61.2177 43.4528 61.9996 46.0307 61.9996 48.6678C61.9957 52.2028 60.5896 55.5919 58.09 58.0915C55.5904 60.5911 52.2013 61.9971 48.6663 62.0011Z"
      fill={glyphFill}
    />
  </svg>
);
